import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
];

export const ClientSubscriptionRoutingProvider = RouterModule.forRoot(routes, { useHash: true });